import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {AccessService} from '../../../utils/AccessService';
import {explorerIsInformes} from '../../../hooks/useReportModality';
import {clientExplorerPath} from '../../informes/informesPaths';

export function QuickActionsBox({clientId, modules, onAddNote, onAddBU, onGenerateReport, generating, readOnly}) {
    const {t} = useTranslation();

    const hasAgent = modules && modules.includes(AccessService.MODULE_AGENT);
    const hasReports = modules && modules.includes(AccessService.MODULE_REPORTS);
    const hasDataExplorer = modules && modules.includes(AccessService.MODULE_DATA_EXPLORER);

    return (
        <div className="box quick-actions-box">
            <h3 className="quick-actions-title">{t('control_central.quick_actions_title')}</h3>
            <div className="quick-actions-grid">
                {hasReports && (
                    <button className="quick-action-btn" onClick={onGenerateReport} disabled={generating}>
                        <FaIcon iconName="wand-magic-sparkles"/>
                        {t('reports.generate_report')}
                    </button>
                )}
                {hasAgent && (
                    <Link className="quick-action-btn" to={`/agent/chat/?client_id=${clientId}`}>
                        <FaIcon iconName="robot"/>
                        {t('control_central.action_ask_dashbito')}
                    </Link>
                )}
                {!readOnly && (
                    <button className="quick-action-btn" onClick={onAddNote}>
                        <FaIcon iconName="book"/>
                        {t('control_central.action_add_note')}
                    </button>
                )}
                {!readOnly && (
                    <button className="quick-action-btn" onClick={onAddBU}>
                        <FaIcon iconName="plus-circle"/>
                        {t('control_central.action_add_bu')}
                    </button>
                )}
                {hasDataExplorer && (
                    <Link className="quick-action-btn -full-width" to={clientExplorerPath(clientId)}>
                        <FaIcon iconName="chart-bar"/>
                        {explorerIsInformes()
                            ? t('control_central.action_informes')
                            : t('control_central.action_data_explorer')}
                    </Link>
                )}
            </div>
        </div>
    );
}
